<template>
	<a class="info" href="#" @click.prevent="loadInfo"><i class="fas fa-info"></i></a>
</template>

<script>
	import {mapState} from 'vuex';
	export default {
		name : "info-icon",
		props : {
			slug : {
				type : String,
				default : ""
			}
		},
		methods : {
			/**
			 * load content for slug.
			 * @return {[type]} [description]
			 */
			loadInfo(){
				//eslint-disable-next-line
				axios.get(`${process.env.VUE_APP_API_URL}info/${this.slug}/${this.series.id}`)
				.then(response => this.handleLoadInfo(response.data))
				//eslint-disable-next-line
				.catch(error => console.log(error));
			},
			/**
			 * send response to store
			 * and trigger info window to open.
			 * @param  {[type]} response [description]
			 * @return {[type]}          [description]
			 */
			handleLoadInfo(response){
				this.$store.commit("setInfoData",response);
				//eslint-disable-next-line
				setTimeout(() => UIkit.toggle(document.getElementById("info-modal")).toggle(),0);
			}
		},
		computed : {
			...mapState({
				series : state => state.wallbed.series
			})
		}
	}
</script>